import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import { getNodeById } from "../../../nodeSelector";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as pathUtils from "../../../utils/pathUtils";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_CONDITION } from "./abstract/conditionAbstract";

const _action = `${ACTION_PREFIX_CONDITION}_copy`;
const _header = `Copy condition`;

export const copyCondition = (root, id) => {
  const _payload = copyConditionLogic(root, id);

  logger.logAction(_action, _payload, ACTION_PREFIX_CONDITION);

  return { root, info: _payload };
};

//--------------------------------------------------------------------------------

export const copyConditionLogic = (root, id) => {
  const { data: _node, index: _index } = getNodeById(root, id);
  if (!_node) {
    throw new Error("Condition to copy not found");
  }
  const { data: _nodeParent } = getNodeById(root, pathUtils.getIdParent(id));
  const { data: _nodeCopy } = nodeUtils.copy(_node, { name: "" });

  const _nodeBackup = systemUtils.createDeepCopy(_node);

  addNodeCopy(_nodeCopy, _nodeParent, _index + 1);

  return generatePayload(_nodeBackup, _index, _nodeParent, _nodeCopy);
};

const addNodeCopy = (nodeCopy, nodeParent, index) => {
  nodeUtils.modifyConditions(nodeParent, (e) => e.splice(index, 0, nodeCopy), false);
};

//--------------------------------------------------------------------------------

const generatePayload = (node, index, nodeParent, nodeCopy) => {
  const _payload = {
    group: ActionGroupTypes.ADD,
    status: ActionStatusTypes.INDIFFERENT,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: generatePayloadDescription(node),
    node: node,
    uuid: nodeUtils.getUUID(node),
    uuidParent: nodeUtils.getUUID(nodeParent),
    index: index,
    uuidCopy: nodeUtils.getUUID(nodeCopy),
  };

  return _payload;
};

const generatePayloadDescription = (node) => {

  if (nodeUtils.isFunction(node)) {
    return `Copy function logic '${nodeUtils.getName(node)}'.`;
  }

  return `Copy structure logic '${nodeUtils.getName(node)}'.`;
}